import React, { useEffect, useRef, useState } from "react";
import "./TestimonialsSection.css";

const TESTIMONIALS = [
  {
    quote:
      "TravXplo’s management made the entire booking process seamless, and their support team was always available whenever we had a question. The best part? At such an affordable price, we got a beautiful, spacious villa in Delhi that exceeded all our expectations. Truly a wonderful experience!",
    name: "Dhanraj – Kolhapur (Business Trip to Delhi)",
    tag: "Traveler",
  },
  {
    quote:
      "We needed quick and reliable return flights from Goa to Thailand for our corporate team, and TravXplo delivered exactly that. Everything was arranged perfectly, tickets confirmed on time, and not a single hiccup along the way.",
    name: "Umesh - – Kolhapur (Flight Booking)",
    tag: "Traveler",
  },
  {
    quote:
"TravXplo organized our Bali trip like a dream, group flights, a beautiful villa, and curated experiences. The whole gang loved it!",
    name: "Vaishnavi – Pune (A Girls Trip to Bali)",
    tag: "Traveler",
    },
      {
    quote:
"Our family trip to Singapore was seamless thanks to TravXplo. Flights, hotels, and experiences were all booked with zero stress.",
    name: "Rutuja – Pune (A Family Trip to Singapore)",
    tag: "Traveler",
    },
      {
    quote:
"TravXplo planned my solo Goa trip end-to-end—flights, hotel, and a day-wise plan. Everything was smooth, and I never felt lost even for a moment.",
    name: "Shrutika – Mumbai (A Solo Trip to Goa)",
    tag: "Traveler",
    },
];

export default function TestimonialsSection() {
  const [index, setIndex] = useState(0);
  const [cardsPerView, setCardsPerView] = useState(1);
  const [paused, setPaused] = useState(false);
  const total = TESTIMONIALS.length;
  const intervalRef = useRef(null);

  // Decide cards per view based on width (no external libs)
  useEffect(() => {
    const decide = () => {
      const w = window.innerWidth;
      if (w >= 1024) setCardsPerView(3);
      else if (w >= 640) setCardsPerView(2);
      else setCardsPerView(1);
    };
    decide();
    window.addEventListener("resize", decide);
    return () => window.removeEventListener("resize", decide);
  }, []);

  const maxIndex = Math.max(0, total - cardsPerView);

  const next = () => setIndex((i) => (i >= maxIndex ? 0 : i + 1));
  const prev = () => setIndex((i) => (i <= 0 ? maxIndex : i - 1));

  // Auto-play
  useEffect(() => {
    if (paused) return;
    intervalRef.current = setInterval(next, 4500);
    return () => clearInterval(intervalRef.current);
  }, [paused, maxIndex, cardsPerView]);

  // Pages for dot indicators (groups, not single cards)
  const pages = Math.max(1, Math.ceil(total / cardsPerView));
  const activePage = Math.floor(index / 1); // we shift by 1 card for a smooth feel

  return (
    <section
      className="txpo-t-section"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
    >
      <div className="txpo-t-container">
        <header className="txpo-t-header">
          <h2>What our travelers & partners say</h2>
          <p>
            Real experiences. Real outcomes. Hand-picked stories that reflect how
            TravXplo plans, simplifies, and elevates travel.
          </p>
        </header>

        <div className="txpo-t-viewport">
          <div
            className="txpo-t-track"
            style={{
              transform: `translateX(-${(index * 100) / cardsPerView}%)`,
              "--cards-per-view": cardsPerView,
            }}
          >
            {TESTIMONIALS.map((t, i) => (
              <article key={i} className="txpo-t-card">
                <div className="txpo-t-quote">“</div>
                <p className="txpo-t-text">{t.quote}</p>
                <div className="txpo-t-meta">
                  <span className="txpo-t-name">{t.name}</span>
                  <span className="txpo-t-tag">{t.tag}</span>
                </div>
              </article>
            ))}
          </div>

          <button aria-label="Previous" className="txpo-t-nav txpo-t-prev" onClick={prev}>
            ‹
          </button>
          <button aria-label="Next" className="txpo-t-nav txpo-t-next" onClick={next}>
            ›
          </button>
        </div>

        <div className="txpo-t-dots">
          {Array.from({ length: pages }).map((_, p) => (
            <button
              key={p}
              className={`txpo-t-dot ${p === activePage ? "is-active" : ""}`}
              onClick={() => setIndex(p)}
              aria-label={`Go to slide ${p + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
